import {
  POSTS_REQUEST, POSTS_SUCCESS, POSTS_FAIL,
  LATEST_POSTS_REQUEST, LATEST_POSTS_SUCCESS, LATEST_POSTS_FAIL,
  POST_REQUEST, POST_SUCCESS, POST_FAIL,
  COMMENT_REQUEST, COMMENT_SUCCESS, COMMENT_FAIL, COMMENT_RESET,
  READ_LATER_ADD, READ_LATER_REMOVE,
  SUBSCRIBE_REQUEST, SUBSCRIBE_SUCCESS, SUBSCRIBE_FAIL, SUBSCRIBE_RESET,
  UNSUBSCRIBE_REQUEST, UNSUBSCRIBE_SUCCESS, UNSUBSCRIBE_FAIL,
} from '../constants/blogConstants'

const storedReadLater = () => {
  try { return JSON.parse(localStorage.getItem('fc_read_later') || '[]') }
  catch { return [] }
}

export const postsReducer = (state = { posts: [] }, action) => {
  switch (action.type) {
    case POSTS_REQUEST: return { ...state, loading: true }
    case POSTS_SUCCESS: return { loading: false, posts: action.payload }
    case POSTS_FAIL:    return { loading: false, error: action.payload }
    default:            return state
  }
}

export const latestPostsReducer = (state = { posts: [] }, action) => {
  switch (action.type) {
    case LATEST_POSTS_REQUEST: return { ...state, loading: true }
    case LATEST_POSTS_SUCCESS: return { loading: false, posts: action.payload }
    case LATEST_POSTS_FAIL:    return { loading: false, error: action.payload }
    default:                   return state
  }
}

export const postReducer = (state = { post: null }, action) => {
  switch (action.type) {
    case POST_REQUEST: return { loading: true, post: null }
    case POST_SUCCESS: return { loading: false, post: action.payload }
    case POST_FAIL:    return { loading: false, error: action.payload }
    default:           return state
  }
}

export const commentReducer = (state = {}, action) => {
  switch (action.type) {
    case COMMENT_REQUEST: return { loading: true }
    case COMMENT_SUCCESS: return { loading: false, success: true }
    case COMMENT_FAIL:    return { loading: false, error: action.payload }
    case COMMENT_RESET:   return {}
    default:              return state
  }
}

export const subscribeReducer = (state = {}, action) => {
  switch (action.type) {
    case SUBSCRIBE_REQUEST: return { loading: true }
    case SUBSCRIBE_SUCCESS: return { loading: false, success: true }
    case SUBSCRIBE_FAIL:    return { loading: false, error: action.payload }
    case SUBSCRIBE_RESET:   return {}
    default:                return state
  }
}

export const unsubscribeReducer = (state = { loading: true }, action) => {
  switch (action.type) {
    case UNSUBSCRIBE_REQUEST: return { loading: true }
    case UNSUBSCRIBE_SUCCESS: return { loading: false, success: true }
    case UNSUBSCRIBE_FAIL:    return { loading: false, error: action.payload }
    default:                  return state
  }
}

export const readLaterReducer = (state = { ids: storedReadLater() }, action) => {
  let newIds
  switch (action.type) {
    case READ_LATER_ADD:
      newIds = [...new Set([...state.ids, action.payload])]
      localStorage.setItem('fc_read_later', JSON.stringify(newIds))
      return { ids: newIds }
    case READ_LATER_REMOVE:
      newIds = state.ids.filter(id => id !== action.payload)
      localStorage.setItem('fc_read_later', JSON.stringify(newIds))
      return { ids: newIds }
    default:
      return state
  }
}
